/* eslint-disable react/no-unescaped-entities */
import { Alert, Input, PrimaryButton } from '@artprov/design-system'
import { useVerificarCodigo } from './verificar-codigo.hook'
import { Show } from '../../../common/components/Show'
import { formatTime, Status } from './lib/utils'
import { useEffect } from 'react'

export function VerificarCodigoSection() {
  const { onSubmit, onReset, onChange, onRequestNewCode, value, disabled, status, error, timeLeft } =
    useVerificarCodigo()

  const handleKeydown = (e) => {
    if (e.key === 'Enter' && !disabled) {
      onSubmit()
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeydown)
    return () => {
      window.removeEventListener('keydown', handleKeydown)
    }
  }, [disabled, onSubmit]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="flex flex-col gap-3 bg-tertiary-98 p-4 rounded ">
      <Show when={status === Status.EXPIRED}>
        <Alert
          variant="error"
          containerStyle="max-w-none "
          title={error?.title}
          description={error?.message}
          autoDismiss={false}
          iconStyle="text-error-10"
          icon="cancel"
          buttonText="Solicitar nuevo código"
          onAction={onRequestNewCode}
        />
      </Show>

      <Show when={[Status.INVALID, Status.ERROR].includes(status)}>
        <Alert
          variant="error"
          containerStyle="max-w-none "
          title={error?.title}
          description={error?.message}
          autoDismiss={false}
          interactive={false}
          iconStyle="text-error-10"
          icon="cancel"
        />
      </Show>

      <Show when={status === Status.REVALIDATE}>
        <Alert
          variant="neutral"
          containerStyle="max-w-none "
          interactive={false}
          autoDismiss={false}
          title="Nuevo código solicitado"
          description="te enviamos el nuevo código a tu correo."
        />
      </Show>

      <span>
        <p>Ingresá el código de verificación que te enviamos por correo y hacé clic en "Continuar".</p>
        <p>Tenés {formatTime(timeLeft)} minutos para ingresarlo antes de que expire.</p>
      </span>
      <div className="flex flex-col gap-8 bg-tertiary-100 p-6 mt-2 border border-tertiary-80 rounded-lg">
        <Input
          type="number"
          label="Código de verificación"
          isRequired
          placeholder="Ingresá el código enviado"
          className="w-full"
          onChange={onChange}
          value={value}
          hints={[]}
          rightFunction={onReset}
        />

        <PrimaryButton type="submit" className="w-full" disabled={disabled} onClick={onSubmit}>
          Continuar
        </PrimaryButton>
      </div>
    </section>
  )
}
